import { createSlice } from '@reduxjs/toolkit';
 
const initialState = {
  message: null,
  type: null,
  promptBoxFocus: false,
  promptBoxHeight: 0
};
 
const toasterSlice = createSlice({
  name: 'toaster',
  initialState,
  reducers: {
    showToast: (state, action) => {
      state.message = action.payload.message;
      state.type = action.payload.type;
    },
    hideToast: (state) => {
      state.message = null;
      state.type = null;
    },
    setPromptBoxFocus: (state, action) => {
      state.promptBoxFocus = action.payload;
    },
    setPromptBoxHeightRedux: (state, action) => {
      state.promptBoxHeight = action.payload;
    }
  }
});
 
export const { showToast, hideToast, setPromptBoxFocus, setPromptBoxHeightRedux } = toasterSlice.actions;
 
export default toasterSlice.reducer;
 